/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskProgSrvcAccomActy
 */
export interface ExecRiskProgSrvcAccomActy {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgSrvcAccomActy
     */
    ActivityCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgSrvcAccomActy
     */
    ExpenseAmt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgSrvcAccomActy
     */
    GrantAmt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgSrvcAccomActy
     */
    RevenueAmt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgSrvcAccomActy
     */
    Desc?: string;
}

/**
 * Check if a given object implements the ExecRiskProgSrvcAccomActy interface.
 */
export function instanceOfExecRiskProgSrvcAccomActy(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskProgSrvcAccomActyFromJSON(json: any): ExecRiskProgSrvcAccomActy {
    return ExecRiskProgSrvcAccomActyFromJSONTyped(json, false);
}

export function ExecRiskProgSrvcAccomActyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskProgSrvcAccomActy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ActivityCd': !exists(json, 'ActivityCd') ? undefined : json['ActivityCd'],
        'ExpenseAmt': !exists(json, 'ExpenseAmt') ? undefined : json['ExpenseAmt'],
        'GrantAmt': !exists(json, 'GrantAmt') ? undefined : json['GrantAmt'],
        'RevenueAmt': !exists(json, 'RevenueAmt') ? undefined : json['RevenueAmt'],
        'Desc': !exists(json, 'Desc') ? undefined : json['Desc'],
    };
}

export function ExecRiskProgSrvcAccomActyToJSON(value?: ExecRiskProgSrvcAccomActy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ActivityCd': value.ActivityCd,
        'ExpenseAmt': value.ExpenseAmt,
        'GrantAmt': value.GrantAmt,
        'RevenueAmt': value.RevenueAmt,
        'Desc': value.Desc,
    };
}

